// @flow

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import type { Match, Location, RouterHistory } from 'react-router-dom'

import qs from 'qs'
import { openModal, type ModalTypes } from '../../redux'
import ShareModal from './components/ShareModal'
import EmailProgramProviderModal from './components/EmailProgramProviderModal'
import SimpleEmailProgramProviderModal from './components/SimpleEmailProgramProviderModal'
import CallProgramProviderModal from './components/CallProgramProviderModal'

const MODAL_COMPONENTS = {
  share: ShareModal,
  email: EmailProgramProviderModal,
  emailFlyerOwner: SimpleEmailProgramProviderModal, // temporary
  callFlyerOwner: CallProgramProviderModal
}

type ReactRouterProps = {|
  match: Match,
  location: Location,
  history: RouterHistory
|}

type ReduxStateProps = {|
  +modalType: ?ModalTypes
|}

type ReduxDispatchProps = {|
  +onOpenModal: (modalType: ?ModalTypes, value) => void
|}

type Props = {|
  ...ReduxStateProps,
  ...ReduxDispatchProps,
  ...ReactRouterProps
|}

class ModalManager extends Component<Props> {
  componentWillMount() {
    const search = this.props.location.search
    const params = qs.parse(search, { ignoreQueryPrefix: true })
    // TECH DEBT: we could move url logic in to redux OR on close of modal, change url
    const showModal = Object.keys(params).indexOf('modal') !== -1
    const { url } = this.props.match
    if (showModal) {
      // 1) extract modal type
      // 2) send action to open correct modal via modal manager
      // 3) remove these params from the url using rr: usermail, modal
      const modalType: ModalTypes = params.modal
      this.props.onOpenModal(modalType, this.props.value)
      this.props.history.push(url)
    }
  }

  render() {
    const { modalType, value } = this.props
    const ModalComponent = MODAL_COMPONENTS[modalType]
    return modalType && <ModalComponent open value={value} />
  }
}

// TODO: create getters (reselect)
const mapStateToProps = (state): ReduxStateProps => ({
  modalType: state.flyerDetails.modalType,
  value: state.flyerDetails.value
})

const mapDispatchToProps = (dispatch): ReduxDispatchProps => ({
  onOpenModal: (modalType, value) => dispatch(openModal(modalType, value))
})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ModalManager)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/ModalManager/ModalManager.js